<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron
                  @click="$router.push({name: 'RecipeTagList'})"/>
                {{ mode === 'create' ? $t('health.recipe.tag.new') : $t('health.recipe.tag.edit') }}
              </h1>
              <alert
                v-if="alertVisible"
                :message="alertMessage"
                :type="alertType">
              </alert>
            </div>
          </grid-col>
        </grid-row>
        <form
          v-on:submit.prevent
          v-on:keypress.enter.prevent="onSave">
          <grid-row column-align="center" col-spaced>
            <grid-col col-size="2">
              <div class="variable-input-field variable-input-field-name">
                <label-input
                  id="nameInput"
                  ref="nameInput"
                  form-size="m"
                  :label="$t('health.recipe.tag.name')"
                  v-model="name"
                  :margin="false"
                  :error="nameError"
                  :errorMessage="displayNameErrorMessage">
                </label-input>
              </div>

            </grid-col>
            <grid-col col-size="2">
              <div class="variable-input-field variable-input-field-name">
                <label-input
                  id="nameEnInput"
                  ref="nameEnInput"
                  form-size="m"
                  :label="$t('health.recipe.tag.nameEn')"
                  v-model="nameEn"
                  :margin="false"
                  :error="nameEnError"
                  :errorMessage="displayNameEnErrorMessage">
                </label-input>
              </div>
            </grid-col>
          </grid-row>
          <grid-row column-align="center" col-spaced>
            <grid-col col-size="4">
              <div class="center-vertical variable-input-field submit-buttons align-right">
                <btn-pill
                  :btnText="$t('health.userProfile.update')"
                  v-on:click="onSave"
                  btn-size="m">
                </btn-pill>
              </div>
            </grid-col>
          </grid-row>
        </form>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Chevron from '@/components/shared/Chevron';
import api from 'BRAND/api/recipe';
import Alert from '@/components/shared/alert/Alert';
import LabelInput from '@/components/shared/forms/LabelInput';
import BtnPill from '@/components/shared/buttons/BtnPill';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

export default {
  name: 'RecipeList',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    FontAwesomeIcon,
    Chevron,
    Alert,
    LabelInput,
    BtnPill
  },
  data () {
    return {
      mode: '',
      breadcrumb: [
        {link: '/workspace', name: this.$t('menu.workspace')},
        {link: '/recipe-tag', name: this.$t('health.recipe.tag.title')},
        {link: '/recipe-tag/add', name: this.$t('health.recipe.tag.new'), disabled: true}
      ],
      /* Alert */
      alertVisible: false,
      alertMessage: '',
      alertType: '', // error, warning, success'
      /* Form */
      id: null,
      name: '',
      nameEn: '',
      /* Error */
      nameError: false,
      nameEnError: false,
      displayNameErrorMessage: '',
      displayNameEnErrorMessage: ''
    };
  },
  created () {
    if (this.$route.params.mode === undefined) {
      this.$router.push({name: 'RecipeTagList'});
    } else if (this.$route.params.mode === 'edit') {
      this.id = this.$route.params.id;
      this.requestTagData(this.id);
    }
    this.mode = this.$route.params.mode;
  },
  computed: {
    getBreadcrumb () {
      return this.breadcrumb;
    }
  },
  methods: {
    requestTagData (id) {
      api.getTagToEdit(this, id)
        .then(response => {
          this.name = response.name;
          this.nameEn = response.nameEn;
        })
        .catch(error => {
          this.alertVisible = true;
          this.alertMessage = error.body.message;
          this.alertType = 'error';
        });
    },
    onSave () {
      this.clearErrors();
      if (this.name === '') {
        this.nameError = true;
        this.displayNameErrorMessage = this.$t('health.recipe.tag.nameRequired');
      } else if (this.nameEn === '') {
        this.nameEnError = true;
        this.displayNameEnErrorMessage = this.$t('health.recipe.tag.nameEnRequired');
      }
      const body = {
        name: this.name,
        nameEn: this.nameEn
      };
      if (this.mode === 'create') {
        this.createTag(body);
      } else {
        this.updateTag(body);
      }
    },
    clearErrors () {
      this.nameError = false;
      this.nameEnError = false;
      this.displayNameErrorMessage = '';
      this.displayNameEnErrorMessage = '';
    },
    createTag (tag) {
      api.addTag(this, tag)
        .then(() => {
          const msg = 'health.recipe.tag.successCreate';
          this.$router.replace({name: 'RecipeTagList', params: {alert: msg}});
        })
        .catch((error) => {
          if (error.response.status === 409) {
            this.nameError = true;
            this.displayNameErrorMessage = this.$t('health.recipe.tag.nameExists');
          } else {
            showAlert(this, this.$t('health.recipe.tag.errorCreate'), 'error');
          }
        });
    },
    updateTag (tag) {
      api.updateTag(this, this.id, tag)
        .then(() => {
          const msg = 'health.recipe.tag.successUpdate';
          this.$router.replace({name: 'RecipeTagList', params: {alert: msg}});
        })
        .catch((error) => {
          if (error.response.status === 409) {
            this.nameError = true;
            this.displayNameErrorMessage = this.$t('health.recipe.tag.nameExists');
          } else {
            showAlert(this, this.$t('health.recipe.tag.errorCreate'), 'error');
          }
        });
    }
  }
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 3000);
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/recipe/EditRecipeTag.vue